// CREATE NEW PATIENT ACTIONS
export const SET_NEW_PATIENT = "SET_NEW_PATIENT";
export const SET_NEW_PATIENT_ID = "SET_NEW_PATIENT_ID";

export const SET_PATIENT = "SET_PATIENT";
export const SET_INIT_PATIENT = "SET_INIT_PATIENT";

// SET HEADER TITLE ACTION
export const SET_HEADER_TITLE = "SET_HEADER_TITLE";

export const SET_AUTHENTICATED_USER  = "SET_AUTHENTICATED_USER";
export const RESET_AUTHENTICATED_USER = "RESET_AUTHENTICATED_USER";

export const SET_DATA_LIST = "SET_DATA_LIST";
